import { getS3Keys } from "./s3Helper";
import { getEnvironment, getEnvironmentKey } from "./mappingHelper";

export function buildPayload(demoConfiguration) {
  const { app, email, companyName, demoDate, vertical, jobId } =
    demoConfiguration;
  const isoDemoDate = new Date(demoDate).toISOString();
  const metaData = {
    [getEnvironmentKey(app)]: `${getEnvironment(demoConfiguration)}`,
    "company-name": `${companyName}`,
    "nulogy-user": `${email}`,
    "demo-date": `${isoDemoDate}`,
    vertical: `${vertical}`,
    "job-id": `${jobId}`,
    "s3-keys": `${getS3Keys(demoConfiguration)}`,
  };
  const environmentVariables = {
    DEPLOY_ENVIRONMENT: `${getEnvironment(demoConfiguration)}`,
    COMPANY_NAME: `${companyName}`,
    NULOGY_USER: `${email}`,
    DEMO_DATE: `${isoDemoDate}`,
    VERTICAL: `${vertical}`,
    S3_KEYS: `${getS3Keys(demoConfiguration)}`,
  };

  return {
    commit: "HEAD",
    branch: "main",
    message: `${email} - Creating demo company named ${companyName} for ${demoDate} :rocket:`,
    meta_data: metaData,
    env: environmentVariables,
  };
}
